import React, { useEffect, useState } from 'react'
import Masonic from 'Components/Masonic/Masonic';
import { Autocomplete, MenuItem, TextField } from '@mui/material';
import { cmbCategoria, cmbMarcas, cmbSucursal, getDegustaciones } from 'actions/portalClientes';
import { useDispatch } from 'react-redux';

interface FiltersValues {
  name: string | null;
  id: number | null;
}

//ts-ignore
const Degustaciones = () => {
  const records = 40;
  const dispatch = useDispatch();
  const [data, setData] = useState<any>([])

  const [categoria, setCategoria] = useState<FiltersValues | null>(null);
  const [marca, setMarca] = useState<FiltersValues | null>(null);
  const [sucursal, setSucursal] = useState<FiltersValues | null>(null);


  const [comboCategoria, setComboCategoria] = useState<Array<FiltersValues>>([])
  const [comboMarca, setComboMarca] = useState<Array<FiltersValues>>([])
  const [comboSucursal, setComboSucursal] = useState<Array<FiltersValues>>([])


  const [page, setPage] = useState<number>(0);
  const [url, setUrl] = useState<string>('')

  const [loading, setLoading] = useState<boolean>(false)


  useEffect(() => {
    if (comboCategoria.length === 0 && comboMarca.length === 0) {
      getAll();
    }
    getData();

  }, [categoria, marca, sucursal])

  const getData = async () => {
    let query = `?records=${records}`;
    let flag = false;

    if (categoria) { query += `&id_category=${categoria.id}` }
    if (marca) { query += `&id_brand=${marca.id}` }
    if (sucursal) { query += `&id_store=${sucursal.id}` }

    if (query !== url) {
      setLoading(true);
      window.scrollTo(0, 0)
      setPage(1);
      setUrl(query);
      query += `&pagination=${1}`
      flag = true
    } else {
      setPage(page + 1);
      query += `&pagination=${page + 1}`
    }

    let response = await getDegustaciones(query);

    if (response) {
      dispatch({
        type: "SET_TOTALPAGES",
        totalPage: response.totalPages
      });
      if (flag) {
        setData(response.data);
      } else {
        setData([...data, ...response.data]);
      }

    } else {
      setData([]);
      dispatch({
        type: "SET_TOTALPAGES",
        totalPage: 1
      });
      setPage(1);
    }
    setLoading(false);
  }

  const getAll = async () => {
    const cmbC = await cmbCategoria();
    const cmbM = await cmbMarcas();
    const cmbS = await cmbSucursal();

    cmbC !== null && setComboCategoria(cmbC);
    cmbM !== null && setComboMarca(cmbM); 
    cmbS !== null && setComboSucursal(cmbS);
  }


  return (
    <div>
      <div style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        alignItems: "center",
        height: "50px"
      }}>
        <Autocomplete
          options={comboCategoria}
          getOptionLabel={(option: any) => option.description}
          onChange={(event: any, value: any) => setCategoria(value)}
          value={categoria}
          fullWidth
          style={{ margin: "0px 20px" }}
          id="cmbCategoria"
          renderInput={(params) => (
            <TextField
              {...params}
              label="Categoria"
              variant="standard"
              inputProps={{ ...params.inputProps }}
            />
          )}
        />
        <Autocomplete
          options={comboMarca}
          getOptionLabel={(option: any) => option.description}
          onChange={(event: any, value: any) => setMarca(value)}
          value={marca}
          fullWidth
          style={{ margin: "0px 20px" }}
          id="cmbMarca"
          renderInput={(params) => (
            <TextField
              {...params}
              label="Marca"
              variant="standard"
              inputProps={{ ...params.inputProps }}
            />
          )}
        />
        <Autocomplete
          options={comboSucursal}
          getOptionLabel={(option: any) => option.name}
          onChange={(event: any, value: any) => setSucursal(value)}
          value={sucursal}
          fullWidth
          style={{ margin: "0px 20px" }}
          id="cmbSucursal"
          renderInput={(params) => (
            <TextField
              {...params}
              label="Tienda"
              variant="standard"
              inputProps={{ ...params.inputProps }}
            />
          )}
        />
      </div>
      <Masonic items={data} fetchData={getData} page={page} loading={loading} />
    </div>
  );
}






export default Degustaciones